"use strict";
var _a;
exports.__esModule = true;
exports.toDocumentType = void 0;
var types_1 = require("../../types");
var PrismicDocumentType;
(function (PrismicDocumentType) {
    PrismicDocumentType["COLD_ARTICLE"] = "cold_article";
    PrismicDocumentType["CONTACT"] = "contact";
    PrismicDocumentType["FINANCIAL_DEBT"] = "financial_debt";
    PrismicDocumentType["FINANCIAL_KEY_FIGURES"] = "financial_key_figures";
    PrismicDocumentType["FINANCIAL_PRESS_RELEASE"] = "financial_press_release";
    PrismicDocumentType["FINANCIAL_PUBLICATION"] = "financial_publication";
    PrismicDocumentType["FINANCIAL_RATING"] = "financial_rating";
    PrismicDocumentType["FOOTER"] = "footer";
    PrismicDocumentType["HEADER"] = "header";
    PrismicDocumentType["HOME"] = "home_page";
    PrismicDocumentType["HOT_ARTICLE"] = "hot_article";
    PrismicDocumentType["HUB_ACTUS"] = "hub_actus";
    PrismicDocumentType["HUB_NEWSROOM"] = "hub_newsroom";
    PrismicDocumentType["LA_POSTE_EN_4"] = "la_poste_en_4";
    PrismicDocumentType["MEDIA_POPIN"] = "media_popin";
    PrismicDocumentType["MEDIA_PRESS"] = "media_presse_v2";
    PrismicDocumentType["NEWSROOM"] = "newsroom";
    PrismicDocumentType["PRESS_RELEASE"] = "press_release";
    PrismicDocumentType["PROFILE"] = "profile";
    PrismicDocumentType["RSE"] = "rse";
    PrismicDocumentType["SEARCH"] = "search_page";
    PrismicDocumentType["SLIDER_POPIN"] = "slider_popin";
    PrismicDocumentType["TIMELINE_POPIN"] = "timeline_popin";
})(PrismicDocumentType || (PrismicDocumentType = {}));
var PRISMIC_TO_LGLP = (_a = {},
    _a[PrismicDocumentType.COLD_ARTICLE] = types_1.DocumentType.COLD_ARTICLE,
    _a[PrismicDocumentType.CONTACT] = types_1.DocumentType.CONTACT,
    _a[PrismicDocumentType.FINANCIAL_DEBT] = types_1.DocumentType.FINANCIAL_DEBT,
    _a[PrismicDocumentType.FINANCIAL_KEY_FIGURES] = types_1.DocumentType.FINANCIAL_KEY_FIGURES,
    _a[PrismicDocumentType.FINANCIAL_PRESS_RELEASE] = types_1.DocumentType.FINANCIAL_PRESS_RELEASE,
    _a[PrismicDocumentType.FINANCIAL_PUBLICATION] = types_1.DocumentType.FINANCIAL_PUBLICATION,
    _a[PrismicDocumentType.FINANCIAL_RATING] = types_1.DocumentType.FINANCIAL_RATING,
    _a[PrismicDocumentType.FOOTER] = types_1.DocumentType.FOOTER,
    _a[PrismicDocumentType.HEADER] = types_1.DocumentType.HEADER,
    _a[PrismicDocumentType.HOME] = types_1.DocumentType.HOME,
    _a[PrismicDocumentType.HOT_ARTICLE] = types_1.DocumentType.HOT_ARTICLE,
    _a[PrismicDocumentType.HUB_ACTUS] = types_1.DocumentType.HUB_ACTUS,
    _a[PrismicDocumentType.HUB_NEWSROOM] = types_1.DocumentType.HUB_NEWSROOM,
    _a[PrismicDocumentType.LA_POSTE_EN_4] = types_1.DocumentType.LA_POSTE_EN_4,
    _a[PrismicDocumentType.MEDIA_POPIN] = types_1.DocumentType.MEDIA_POPIN,
    _a[PrismicDocumentType.MEDIA_PRESS] = types_1.DocumentType.MEDIA_PRESS,
    _a[PrismicDocumentType.NEWSROOM] = types_1.DocumentType.NEWSROOM,
    _a[PrismicDocumentType.PRESS_RELEASE] = types_1.DocumentType.PRESS_RELEASE,
    _a[PrismicDocumentType.PROFILE] = types_1.DocumentType.PROFILE,
    _a[PrismicDocumentType.RSE] = types_1.DocumentType.RSE,
    _a[PrismicDocumentType.SEARCH] = types_1.DocumentType.SEARCH,
    _a[PrismicDocumentType.SLIDER_POPIN] = types_1.DocumentType.SLIDER_POPIN,
    _a[PrismicDocumentType.TIMELINE_POPIN] = types_1.DocumentType.TIMELINE_POPIN,
    _a);
var toDocumentType = function (prismicDocumentType, logger) {
    return logger.toConstValue(prismicDocumentType, PRISMIC_TO_LGLP);
};
exports.toDocumentType = toDocumentType;
//# sourceMappingURL=document-type.js.map